<template>
  <div>
    <transition name="modal">
      <ModalError v-if="store.error" @close="store.error = null" @support="openSupportForm($event)" />
      <FormsContact v-else-if="orderNumber" :subject="t('helpContactSubject', { id: orderNumber })" @close="orderNumber = null" />
    </transition>
    <LazyUtilsPageLoading v-show="store.loading" />
    <NuxtLoadingIndicator />
    <NuxtLayout class="bg-light">
      <NuxtPage />
    </NuxtLayout>
    <UtilsCookieSection />
  </div>
</template>
<script setup lang="ts">
  import { useStore } from '~/stores/main'

  const store = useStore()
  const { t, locale } = useI18n()

  async function getDynamicSeo() {
    const { data } = await requestData(ApiIdentifier.STRAPI_CMS, `store-web-dynamic-seos?_locale=${locale.value}`)
    if (data && data.length > 0) {
      store.customSEO = data
    }
  }

  getDynamicSeo()

  await useAsyncData('mainCategoriesPromos', async () => {
    if (!store.categories || !store.promos) {
      await Promise.all([!store.categories && getProductCategories(), !store.promos && getActivePromos()])
    }

    return store.categories && store.promos
  })

  const orderNumber = ref<number | null>(null)

  function openSupportForm(number: number) {
    store.error = null
    orderNumber.value = number
  }
</script>
